module.exports = __webpack_public_path__ + "static/media/B-7ths.051e7f6d.png";